module.exports = __webpack_public_path__ + "static/media/player-12.7a4eb58f.svg";